import type { ComponentProps } from 'react';

const RoundedAddition = (props: ComponentProps<'svg'>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <g clip-path="url(#clip0_10325_12953)">
        <path
          d="M11.9961 2.25C14.582 2.25 17.0619 3.27723 18.8904 5.10571C20.7189 6.93419 21.7461 9.41414 21.7461 12C21.7461 14.5859 20.7189 17.0658 18.8904 18.8943C17.0619 20.7228 14.582 21.75 11.9961 21.75C9.41023 21.75 6.93028 20.7228 5.1018 18.8943C3.27332 17.0658 2.24609 14.5859 2.24609 12C2.24609 9.41414 3.27332 6.93419 5.1018 5.10571C6.93028 3.27723 9.41023 2.25 11.9961 2.25ZM11.9961 24C15.1787 24 18.2309 22.7357 20.4814 20.4853C22.7318 18.2348 23.9961 15.1826 23.9961 12C23.9961 8.8174 22.7318 5.76516 20.4814 3.51472C18.2309 1.26428 15.1787 0 11.9961 0C8.8135 0 5.76125 1.26428 3.51081 3.51472C1.26038 5.76516 -0.00390625 8.8174 -0.00390625 12C-0.00390625 15.1826 1.26038 18.2348 3.51081 20.4853C5.76125 22.7357 8.8135 24 11.9961 24ZM10.8711 16.125C10.8711 16.7484 11.3727 17.25 11.9961 17.25C12.6195 17.25 13.1211 16.7484 13.1211 16.125V13.125H16.1211C16.7445 13.125 17.2461 12.6234 17.2461 12C17.2461 11.3766 16.7445 10.875 16.1211 10.875H13.1211V7.875C13.1211 7.25156 12.6195 6.75 11.9961 6.75C11.3727 6.75 10.8711 7.25156 10.8711 7.875V10.875H7.87109C7.24766 10.875 6.74609 11.3766 6.74609 12C6.74609 12.6234 7.24766 13.125 7.87109 13.125H10.8711V16.125Z"
          fill="#8C98AB"
        />
      </g>
      <defs>
        <clipPath id="clip0_10325_12953">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default RoundedAddition;
